// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 204 ? "fdd47866" : chunkId) + "." + {"63":"126560bf095242b0","204":"b1dbc5aa875f89cc","444":"32a99da57cb9d189"}[chunkId] + ".js";
};